<template>
  <v-app-bar
    :color="background"
    height="auto"
    class="mt-5 px-0 mx-6 border-radius-xl toolbar-content-padding-y-none"
    :class="
      navbarFixed
        ? 'position-sticky blur shadow-blur top-1 z-index-sticky py-2'
        : ''
    "
    flat
    id="app-bar"
  >
    <v-row class="py-1">
      <v-col cols="12" sm="6" class="d-flex">
        <div>
          <v-breadcrumbs class="pb-0 pt-1 px-0">
            <v-breadcrumbs-item
              to="/dashboard"
              active-class="active-breadcrumb"
              class="opacity-5 text-dark"
            >
              <svg
                width="12px"
                height="12px"
                class="mb-1"
                viewBox="0 0 45 40"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <title>Home</title>
                <g
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <g
                    transform="translate(-1716.000000, -439.000000)"
                    fill="#252f40"
                    fill-rule="nonzero"
                  >
                    <g transform="translate(1716.000000, 291.000000)">
                      <g transform="translate(0.000000, 148.000000)">
                        <path
                          d="M46.7199583,10.7414583 L40.8449583,0.949791667 C40.4909749,0.360605034 39.8540131,0 39.1666667,0 L7.83333333,0 C7.1459869,0 6.50902508,0.360605034 6.15504167,0.949791667 L0.280041667,10.7414583 C0.0969176761,11.0460037 -1.23209662e-05,11.3946378 -1.23209662e-05,11.75 C-0.00758042603,16.0663731 3.48367543,19.5725301 7.80004167,19.5833333 L7.81570833,19.5833333 C9.75003686,19.5882688 11.6168794,18.8726691 13.0522917,17.5760417 C16.0171492,20.2556967 20.5292675,20.2556967 23.494125,17.5760417 C26.4604562,20.2616016 30.9794188,20.2616016 33.94575,17.5760417 C36.2421905,19.6477597 39.5441143,20.1708521 42.3684437,18.9103691 C45.1927731,17.649886 47.0084685,14.8428276 47.0000295,11.75 C47.0000295,11.3946378 46.9030823,11.0460037 46.7199583,10.7414583 Z"
                        ></path>
                        <path
                          d="M39.198,22.4912623 C37.3776246,22.4928106 35.5817531,22.0149171 33.951625,21.0951667 L33.92225,21.1107282 C31.1430221,22.6838032 27.9255001,22.9318916 24.9844167,21.7998837 C24.4750389,21.605469 23.9777983,21.3722567 23.4960833,21.1018359 L23.4745417,21.1129513 C20.6961809,22.6871153 17.4786145,22.9344611 14.5386667,21.7998837 C14.029926,21.6054643 13.533337,21.3722507 13.0522917,21.1018359 C11.4250962,22.0190609 9.63246555,22.4947009 7.81570833,22.4912623 C7.16510551,22.4842162 6.51607673,22.4173045 5.875,22.2911849 L5.875,44.7220845 C5.875,45.9498589 6.7517757,46.9451667 7.83333333,46.9451667 L19.5833333,46.9451667 L19.5833333,33.6066734 L27.4166667,33.6066734 L27.4166667,46.9451667 L39.1666667,46.9451667 C40.2482243,46.9451667 41.125,45.9498589 41.125,44.7220845 L41.125,22.2822926 C40.4887822,22.4116582 39.8442868,22.4815492 39.198,22.4912623 Z"
                        ></path>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </v-breadcrumbs-item>
            <li class="v-breadcrumbs__divider opacity-5 px-2 text-muted">/</li>
            <v-breadcrumbs-item class="opacity-5 text-dark">
              {{ translateAppBarLabel($route.meta.groupName) }}
            </v-breadcrumbs-item>
            <li class="v-breadcrumbs__divider opacity-5 px-2 text-muted">/</li>
            <v-breadcrumbs-item
              active-class="active-breadcrumb"
              class="no-default-hover text-dark"
            >
              {{ translateAppBarLabel($route.name) }}
            </v-breadcrumbs-item>
          </v-breadcrumbs>

          <h6 class="text-h6 font-weight-bolder text-typo mb-0">
            {{ translateAppBarLabel($route.name) }}
          </h6>
        </div>
        <div
          class="drawer-toggler pa-5 ms-6 cursor-pointer"
          :class="{ active: togglerActive }"
          @click="minifyDrawer"
          v-if="!$vuetify.breakpoint.mobile"
        >
          <div class="drawer-toggler-inner">
            <i class="drawer-toggler-line bg-body"></i>
            <i class="drawer-toggler-line bg-body"></i>
            <i class="drawer-toggler-line bg-body"></i>
          </div>
        </div>
      </v-col>

      <v-col
        cols="12"
        sm="6"
        class="align-right"
        :class="$vuetify.rtl ? 'text-sm-left' : 'text-sm-right'"
      >
        <v-btn
          elevation="0"
          :ripple="false"
          height="39"
          class="
            font-weight-600
            text-capitalize
            drawer-toggler
            py-3
            px-0
            rounded-sm
          "
          :class="{
            'btn-dark-toggler-hover': !hasBg,
            'btn-toggler-hover': hasBg,
            active: togglerActive,
          }"
          v-if="$vuetify.breakpoint.mobile"
          color="transparent"
          @click="drawerClose"
        >
          <div class="drawer-toggler-inner">
            <i class="drawer-toggler-line text-body"></i>
            <i class="drawer-toggler-line text-body"></i>
            <i class="drawer-toggler-line text-body"></i>
          </div>
        </v-btn>

        <!-- <v-btn
          icon
          :ripple="false"
          :class="{ 'btn-dark-hover': !hasBg, 'btn-hover': hasBg }"
          class="text-body"
          :color="linkColor"
          small
          @click="$emit('toggleSettingsDrawer', true)"
        >
          <v-icon size="16">fa fa-cog text-sm</v-icon>
        </v-btn> -->

        <!-- <v-menu
          transition="slide-y-transition"
          offset-y
          offset-x
          min-width="300"
          max-width="300"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              :ripple="false"
              :class="{ 'btn-dark-hover': !hasBg, 'btn-hover': hasBg }"
              class="text-body"
              :color="linkColor"
              v-bind="attrs"
              v-on="on"
              small
            >
              <v-icon size="16">fa fa-bell text-sm</v-icon>
            </v-btn>
          </template>

           <v-list class="py-0">
            <v-list-item
              v-for="(item, i) in dropdown"
              :key="i"
              class="pa-4 list-item-hover-active"
            >
              <v-list-item-avatar
                :size="36"
                class="my-0 me-4 border-radius-lg"
                v-if="item.avatar"
              >
                <v-img
                  :alt="`${item.avatar} avatar`"
                  :src="item.avatar"
                ></v-img>
              </v-list-item-avatar>

              <v-list-item-avatar
                :size="36"
                class="my-0 me-4 border-radius-lg bg-gradient-default"
                v-if="item.image"
              >
                <v-img :alt="`${item.image} image`" :src="item.image"></v-img>
              </v-list-item-avatar>

              <v-list-item-avatar
                :size="36"
                class="my-0 me-4 border-radius-lg bg-gradient-secondary"
                v-if="item.icon"
              >
                <v-img
                  :alt="`${item.icon} icon`"
                  :src="item.icon"
                  class="pa-2"
                  width="10"
                  height="10"
                  contain
                ></v-img>
              </v-list-item-avatar>

              <v-list-item-content class="pa-0">
                <v-list-item-title
                  class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                >
                  <v-row>
                    <v-col>
                      <h6
                        class="text-sm font-weight-normal mb-1 text-typo"
                        v-html="item.title"
                      >
                        {{ item.title }}
                      </h6>
                    </v-col>
                  </v-row>
                </v-list-item-title>

                <p class="text-xs text-secondary mb-0">
                  <v-icon size="12" class="text-secondary"
                    >fa fa-clock me-1</v-icon
                  >
                  {{ item.time }}
                </p>
              </v-list-item-content>
            </v-list-item>
          </v-list> 
        </v-menu> -->

        <div class="d-inline-flex align-center">
          <TutorialsList
            :has-bg="hasBg"
            :link-color="linkColor"
            position-relative
          />
          <v-badge
            :content="unreadBadge"
            :value="hasUnread"
            color="error"
            overlap
            :class="[
              'ma-2',
              'notification-badge-wrapper',
              {
                'notification-badge-wrapper--unread': hasUnread,
                'notification-badge-wrapper--boost': attentionBoostActive,
                'notification-badge-wrapper--pulse': attentionPulse,
              },
            ]"
            content-class="notification-badge"
          >
            <v-btn
              icon
              :ripple="false"
              :class="{
                'btn-dark-hover': !hasBg,
                'btn-hover': hasBg,
                'notification-trigger': true,
                'notification-trigger--unread': hasUnread,
                'notification-trigger--boost': attentionBoostActive,
                'notification-trigger--pulse': attentionPulse,
              }"
              class="text-body"
              :color="linkColor"
              small
              :title="notificationTitle"
              :aria-label="notificationTitle"
              @click="openNotifications"
            >
              <v-icon
                size="24"
                :class="{
                  'notification-alert': hasUnread,
                  'notification-bell-ring': hasUnread && !attentionBoostActive,
                  'notification-bell-boost': attentionBoostActive,
                }"
              >
                fa fa-bell text-sm
              </v-icon>
            </v-btn>
          </v-badge>
          <span
            v-if="hasUnread && !$vuetify.breakpoint.xsOnly"
            class="
              badge
              text-xs
              px-2
              py-1
              border-radius-md
              ms-1
              notification-count-text
            "
            aria-live="polite"
          >
            {{ unreadSummary }}
          </span>
        </div>
        <v-btn
          icon
          :ripple="false"
          :class="{ 'btn-dark-hover': !hasBg, 'btn-hover': hasBg }"
          class="text-body ma-2"
          :color="linkColor"
          small
          to="/dashboard/usuario"
          :title="$t('perfil')"
        >
          <v-icon size="20">fa fa-user me-sm-2 text-sm</v-icon>
        </v-btn>
        <v-btn
          icon
          :ripple="false"
          :class="{ 'btn-dark-hover': !hasBg, 'btn-hover': hasBg }"
          class="text-body ma-2"
          :color="linkColor"
          small
          @click="logout()"
          :title="$t('Sair')"
        >
          <v-icon size="20">ni-button-power</v-icon>
          <!-- {{ $t("Sair") }} -->
        </v-btn>

        <v-dialog v-model="notificationsDialog" max-width="640">
          <v-card class="border-radius-xl">
            <v-card-title class="py-4 px-4 d-flex align-center border-bottom">
              <div>
                <h6 class="text-h6 font-weight-bolder text-typo mb-1">
                  {{ $t("notifications") }}
                </h6>
                <p class="text-sm text-secondary mb-0">
                  {{ unreadSummary }}
                </p>
              </div>
              <v-spacer></v-spacer>
              <v-btn
                text
                small
                color="primary"
                class="text-capitalize"
                :disabled="!hasUnread || notificationsLoading"
                @click="markAllAsRead"
              >
                {{ $t("Marcar_todas_como_lidas") }}
              </v-btn>
              <v-btn icon :ripple="false" @click="notificationsDialog = false">
                <v-icon size="18" class="text-typo">fas fa-times</v-icon>
              </v-btn>
            </v-card-title>

            <v-card-text class="px-4 py-4">
              <v-progress-linear
                v-if="notificationsLoading"
                indeterminate
                color="primary"
                class="mb-4"
              ></v-progress-linear>

              <v-alert
                v-if="notificationsError"
                type="error"
                dense
                text
                class="mb-4"
              >
                {{ notificationsError }}
              </v-alert>

              <div
                v-if="
                  !notificationsLoading &&
                  !notificationsError &&
                  orderedNotifications.length === 0
                "
                class="text-center text-secondary py-6"
              >
                <v-icon size="24" class="mb-2">fa fa-bell-slash</v-icon>
                <div>{{ $t("Nenhuma_notificacao_no_momento") }}</div>
              </div>

              <div v-else>
                <div
                  v-for="item in orderedNotifications"
                  :key="item.id"
                  class="pa-4 mb-3 border-radius-lg border"
                  :class="{ 'bg-light': !isNotificationRead(item) }"
                >
                  <div class="d-flex align-center mb-2">
                    <div class="flex-grow-1">
                      <h6 class="text-sm font-weight-bolder text-typo mb-1">
                        {{ item.assunto || $t("Sem_assunto") }}
                      </h6>
                      <p
                        v-if="item.dtInclusao"
                        class="text-xs text-secondary mb-0"
                      >
                        {{ $t("Recebida_em") }}
                        {{ item.dtInclusao | dataParaLeitura }}
                      </p>
                    </div>
                    <span
                      v-if="!isNotificationRead(item)"
                      class="
                        badge
                        bg-gradient-info
                        text-white text-xs
                        px-2
                        py-1
                        border-radius-md
                      "
                    >
                      {{ $t("Nao_lida") }}
                    </span>
                  </div>

                  <p class="text-sm text-typo mb-3">
                    {{ item.mensagem || $t("Sem_mensagem") }}
                  </p>

                  <div class="d-flex align-center">
                    <v-btn
                      v-if="item.url"
                      small
                      color="primary"
                      class="
                        ma-1
                        font-weight-bold
                        text-none
                        btn-primary
                        bg-gradient-primary
                        py-3
                        px-6
                        ms-3
                      "
                      :loading="actionNotificationId === item.id"
                      @click="openNotification(item)"
                    >
                      {{ $t("Abrir") }}
                    </v-btn>
                    <v-btn
                      v-else
                      small
                      color="secondary"
                      class="text-capitalize"
                      disabled
                    >
                      {{ $t("Sem_link") }}
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                      v-if="!isNotificationRead(item)"
                      small
                      text
                      color="primary"
                      class="text-capitalize"
                      :loading="actionNotificationId === item.id"
                      @click="markAsRead(item)"
                    >
                      {{ $t("Marcar_como_lida") }}
                    </v-btn>
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-col>
      <v-col v-if="topNavigationItems.length > 1" cols="12" class="pt-0">
        <nav
          v-if="!isTopNavigationCompact"
          class="top-menu-switch"
          aria-label="Navegação do módulo atual"
        >
          <v-btn
            v-for="item in topNavigationItems"
            :key="`${item.groupTitle}-${item.link}`"
            :to="navigationTarget(item)"
            small
            depressed
            :ripple="false"
            class="top-menu-switch__item"
            :class="{
              'top-menu-switch__item--active': isNavigationItemActive(item),
            }"
            :title="translatedNavigationLabel(item)"
            :aria-current="isNavigationItemActive(item) ? 'page' : null"
            :data-tutorial-menu-link="item.link"
            :data-tutorial-menu-title="item.title"
            data-tutorial-menu-source="top"
          >
            <v-icon v-if="item.prefix" size="15" left>
              {{ item.prefix }}
            </v-icon>
            <span class="top-menu-switch__label">
              {{ translatedNavigationLabel(item) }}
            </span>
          </v-btn>
        </nav>

        <div v-else class="top-menu-mobile">
          <v-menu
            offset-y
            bottom
            content-class="top-menu-mobile__content"
            max-height="360"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                block
                depressed
                :ripple="false"
                class="top-menu-mobile__trigger"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon v-if="currentNavigationIcon" size="17" left>
                  {{ currentNavigationIcon }}
                </v-icon>
                <span class="top-menu-mobile__trigger-label">
                  {{ currentNavigationLabel }}
                </span>
                <v-icon size="18" right>mdi-chevron-down</v-icon>
              </v-btn>
            </template>

            <v-list dense class="top-menu-mobile__list">
              <v-list-item
                v-for="item in topNavigationItems"
                :key="`${item.groupTitle}-${item.link}-mobile`"
                :to="navigationTarget(item)"
                :ripple="false"
                class="top-menu-mobile__item"
                :class="{
                  'top-menu-mobile__item--active': isNavigationItemActive(item),
                }"
                :data-tutorial-menu-link="item.link"
                :data-tutorial-menu-title="item.title"
                data-tutorial-menu-source="top"
              >
                <v-list-item-icon v-if="item.prefix" class="me-3">
                  <v-icon size="17">{{ item.prefix }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="top-menu-mobile__item-title">
                    {{ translatedNavigationLabel(item) }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </v-col>
    </v-row>
  </v-app-bar>
</template>
<script>
import TutorialsList from "@/components/TutorialsList.vue";
import UsuarioNotificacaoDataService from "@/services/acessos/UsuarioNotificacaoDataService";
import {
  buildMenuNavigationGroups,
  findActiveMenuLink,
  routeMatchesMenuLink,
} from "@/utils/menuNavigation";
import {
  getLoginRouteByBrand,
  isClientWhiteLabel,
  resolveAppWhiteLabelBrand,
  resolveWhiteLabelBrandFromTenantName,
} from "@/utils/whiteLabel";

export default {
  name: "app-bar",
  components: { TutorialsList },
  props: {
    background: String,
    hasBg: Boolean,
    linkColor: String,
    toggleActive: {
      type: Boolean,
      default: false,
    },
    navbarFixed: {
      type: Boolean,
      default: false,
    },
    navigationItems: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      drawer: false,
      togglerActive: this.$vuetify.breakpoint.mobile
        ? !!this.toggleActive
        : false,
      notificationsDialog: false,
      notifications: [],
      notificationsLoading: false,
      pendingNotificationsRefresh: false,
      notificationsRefreshTimer: null,
      notificationsError: "",
      actionNotificationId: null,
      attentionPulse: false,
      attentionTimeout: null,
      attentionBoostWindowActive: false,
      attentionBoostTimeout: null,
      lastMenuPathByRoot: {},
      dropdown: [
        {
          avatar: require("@/assets/img/team-2.jpg"),
          title:
            '<span class="font-weight-bold">New message</span> from Laur</h6>',
          time: "13 minutes ago",
        },
        {
          image: require("@/assets/img/small-logos/logo-spotify.svg"),
          title:
            '<span class="font-weight-bold">New album</span> by Travis Scott',
          time: "1 day",
        },
        {
          icon: require("@/assets/img/icons/card.svg"),
          title: "Payment successfully completed",
          time: "2 days",
        },
      ],
    };
  },
  computed: {
    unreadCount() {
      return this.notifications.filter((item) => !this.isNotificationRead(item))
        .length;
    },
    unreadBadge() {
      if (this.unreadCount > 99) return "99+";
      return this.unreadCount;
    },
    unreadSummary() {
      if (!this.unreadCount) {
        return this.$t("Nenhuma_nao_lida");
      }
      const label =
        this.unreadCount === 1 ? this.$t("nao_lida") : this.$t("nao_lidas");
      return `${this.unreadCount} ${label}`;
    },
    notificationTitle() {
      if (!this.hasUnread) {
        return this.$t("notifications");
      }
      return `${this.$t("notifications")} - ${this.unreadSummary}`;
    },
    attentionBoostActive() {
      return this.hasUnread && this.attentionBoostWindowActive;
    },
    hasUnread() {
      return this.unreadCount > 0;
    },
    orderedNotifications() {
      const items = Array.isArray(this.notifications)
        ? [...this.notifications]
        : [];
      return items.sort((a, b) => {
        const dateA = a?.dtInclusao || "";
        const dateB = b?.dtInclusao || "";
        if (dateA === dateB) return 0;
        return dateA > dateB ? -1 : 1;
      });
    },
    currentTenantId() {
      return this.$store.state.inquilino?.id || "sem-inquilino";
    },
    isOrgaoPublicoTenant() {
      const tipoContratacao = this.$store?.state?.inquilino?.tipoContratacao;
      if (tipoContratacao) {
        return tipoContratacao === "ORGAOPUBLICO";
      }

      try {
        return (
          JSON.parse(localStorage.getItem("inquilino") || "{}")
            ?.tipoContratacao === "ORGAOPUBLICO"
        );
      } catch {
        return false;
      }
    },
    menuMemoryStorageKey() {
      return `cajupe:last-menu-path-by-root:${this.currentTenantId}`;
    },
    menuNavigationGroups() {
      return buildMenuNavigationGroups(
        this.navigationItems,
        this.$store.state.permissoes || []
      );
    },
    activeMenuLink() {
      return findActiveMenuLink(
        this.menuNavigationGroups,
        this.$route.path,
        this.$route.meta?.groupName
      );
    },
    activeMenuGroup() {
      return this.activeMenuLink?.group || null;
    },
    topNavigationItems() {
      return this.activeMenuGroup?.links || [];
    },
    isTopNavigationCompact() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    currentNavigationLabel() {
      return this.activeMenuLink
        ? this.translatedNavigationLabel(this.activeMenuLink)
        : this.translateAppBarLabel(this.$route.name);
    },
    currentNavigationIcon() {
      return this.activeMenuLink?.prefix || "";
    },
  },
  created() {
    this.restoreNavigationMemory();
    this.fetchNotifications();
  },
  mounted() {
    if (typeof window === "undefined") return;
    this.attentionBoostWindowActive = true;
    this.attentionBoostTimeout = setTimeout(() => {
      this.attentionBoostWindowActive = false;
      this.attentionBoostTimeout = null;
    }, 30000);
    this.pushListener = (event) => {
      const fn = String(event?.detail?.functionName || "").toUpperCase();
      if (fn === "ATUALIZANOTIFICACOES") {
        this.fetchNotifications();
        this.scheduleNotificationsRefreshRetry();
      }
    };
    window.addEventListener("push:function", this.pushListener);
  },
  beforeDestroy() {
    if (typeof window === "undefined") return;
    if (this.pushListener) {
      window.removeEventListener("push:function", this.pushListener);
    }
    if (this.notificationsRefreshTimer) {
      clearTimeout(this.notificationsRefreshTimer);
      this.notificationsRefreshTimer = null;
    }
    if (this.attentionTimeout) {
      clearTimeout(this.attentionTimeout);
      this.attentionTimeout = null;
    }
    if (this.attentionBoostTimeout) {
      clearTimeout(this.attentionBoostTimeout);
      this.attentionBoostTimeout = null;
    }
  },
  methods: {
    resolveTenantLabelKey(value) {
      if (!this.isOrgaoPublicoTenant) {
        return value;
      }

      const labelOverrides = {
        clientes: "Lotacoes",
        cliente: "Lotacao",
        cadastro_cliente: "cadastro.Lotacao",
        "cadastro.cliente": "cadastro.Lotacao",
        "editar.cliente": "editar.lotacao",
        postotrabalhos: "LocalTrabalho",
        postotrabalho: "LocalTrabalho",
        "cadastro.postotrabalhos": "cadastro.LocalTrabalho",
        "cadastro.postotrabalho": "cadastro.LocalTrabalho",
        "editar.postotrabalho": "editar.localtrabalho",
        funcionarios: "Servidores",
        funcionario: "Servidor",
        "cadastro.funcionario": "cadastro.Servidor",
        "cadastro.funcionarioresumed": "cadastro.Servidor",
        "editar.funcionario": "editar.servidor",
        beneficioanalisecliente: "BeneficioAnaliseLotacao",
        "beneficio.analise.cliente": "beneficio.analise.lotacao",
        funcionarioregistrador: "ServidorRegistrador",
        funcionariopontoweb: "ServidorPontoWeb",
      };

      const normalizedValue = String(value || "").trim();
      const normalizedKey = normalizedValue.toLowerCase();

      return (
        labelOverrides[normalizedValue] ||
        labelOverrides[normalizedKey] ||
        value
      );
    },
    translateAppBarLabel(value) {
      const normalizedValue = this.resolveTenantLabelKey(
        String(value || "").trim()
      );
      if (!normalizedValue) return "";

      const translationKey = [
        normalizedValue,
        normalizedValue.toLowerCase(),
      ].find((key) => this.$te(key));

      return translationKey ? this.$t(translationKey) : normalizedValue;
    },
    translatedNavigationLabel(item) {
      return this.translateAppBarLabel(item?.title);
    },
    navigationTarget(item) {
      const rootLink = item?.rootLink || item?.link;
      return this.lastMenuPathByRoot[rootLink] || item?.link;
    },
    isNavigationItemActive(item) {
      return (
        !!item?.link &&
        routeMatchesMenuLink(this.$route.path, item.link) &&
        this.activeMenuLink?.link === item.link
      );
    },
    restoreNavigationMemory() {
      if (typeof window === "undefined") return;
      try {
        const stored = window.sessionStorage.getItem(this.menuMemoryStorageKey);
        const parsed = stored ? JSON.parse(stored) : {};
        this.lastMenuPathByRoot =
          parsed && typeof parsed === "object" && !Array.isArray(parsed)
            ? parsed
            : {};
      } catch (error) {
        this.lastMenuPathByRoot = {};
      }
    },
    persistNavigationMemory() {
      if (typeof window === "undefined") return;
      try {
        window.sessionStorage.setItem(
          this.menuMemoryStorageKey,
          JSON.stringify(this.lastMenuPathByRoot)
        );
      } catch (error) {
        return undefined;
      }
    },
    rememberCurrentRoute() {
      if (!this.activeMenuLink) return;
      const rootLink = this.activeMenuLink.rootLink || this.activeMenuLink.link;
      const target = this.$route.fullPath || this.$route.path;
      if (!rootLink || !target) return;

      this.$set(this.lastMenuPathByRoot, rootLink, target);
      this.persistNavigationMemory();
    },
    drawerClose() {
      const nextState = !this.toggleActive;
      this.togglerActive = nextState;
      this.$emit("drawer-toggle", nextState);
    },
    minifyDrawer() {
      this.togglerActive = !this.togglerActive;
      this.mini = !this.mini;
      const body = document.getElementsByTagName("body")[0];

      if (body.classList.contains("drawer-mini")) {
        body.classList.remove("drawer-mini");
      } else {
        body.classList.add("drawer-mini");
      }
    },

    logout: function () {
      this.$store.dispatch("AUTH_LOGOUT").then(() => {
        const fantasia = this.$store.state.inquilino.fantasia;
        const currentBrand = resolveAppWhiteLabelBrand();
        const tenantBrand = resolveWhiteLabelBrandFromTenantName(fantasia);
        const loginBrand = isClientWhiteLabel(currentBrand)
          ? currentBrand
          : tenantBrand;

        this.$router.push(getLoginRouteByBrand(loginBrand));
      });
    },
    home: function () {
      this.$router.push("/dashboard");
    },
    isNotificationRead(item) {
      return item?.lida === true;
    },
    openNotifications() {
      this.notificationsDialog = true;
      this.fetchNotifications();
    },
    fetchNotifications() {
      if (this.notificationsLoading) {
        this.pendingNotificationsRefresh = true;
        return;
      }
      this.notificationsLoading = true;
      this.pendingNotificationsRefresh = false;
      this.notificationsError = "";
      UsuarioNotificacaoDataService.findMyRecords()
        .then((response) => {
          const list = response?.data;
          this.notifications = Array.isArray(list) ? list : [];
        })
        .catch(() => {
          this.notificationsError = this.$t(
            "Nao_foi_possivel_carregar_as_notificacoes"
          );
        })
        .finally(() => {
          this.notificationsLoading = false;
          if (this.pendingNotificationsRefresh) {
            this.pendingNotificationsRefresh = false;
            this.fetchNotifications();
          }
        });
    },
    scheduleNotificationsRefreshRetry() {
      if (this.notificationsRefreshTimer) {
        clearTimeout(this.notificationsRefreshTimer);
      }
      this.notificationsRefreshTimer = setTimeout(() => {
        this.notificationsRefreshTimer = null;
        this.fetchNotifications();
      }, 900);
    },
    markAsRead(item) {
      if (!item || this.isNotificationRead(item)) {
        return Promise.resolve();
      }
      this.actionNotificationId = item.id;
      return UsuarioNotificacaoDataService.marcarComoLida(item.id)
        .then(() => {
          item.lida = true;
        })
        .catch(() => {
          this.notificationsError = this.$t(
            "Nao_foi_possivel_marcar_como_lida"
          );
        })
        .finally(() => {
          this.actionNotificationId = null;
        });
    },
    markAllAsRead() {
      if (!this.hasUnread || this.notificationsLoading) return;
      this.notificationsLoading = true;
      this.notificationsError = "";
      UsuarioNotificacaoDataService.marcarTodasComoLidas()
        .then(() => {
          this.notifications = this.notifications.map((item) => ({
            ...item,
            lida: true,
          }));
        })
        .catch(() => {
          this.notificationsError = this.$t(
            "Nao_foi_possivel_marcar_todas_como_lidas"
          );
        })
        .finally(() => {
          this.notificationsLoading = false;
        });
    },
    openNotification(item) {
      if (!item || !item.url) return;
      const navigate = () => {
        this.notificationsDialog = false;
        this.goToNotificationUrl(item.url);
      };
      const result = this.markAsRead(item);
      if (result && typeof result.finally === "function") {
        result.finally(navigate);
      } else {
        navigate();
      }
    },
    goToNotificationUrl(url) {
      if (!url) return;
      const isExternal = /^https?:\/\//i.test(url);
      if (isExternal) {
        window.open(url, "_blank", "noopener,noreferrer");
        return;
      }
      const target = url.startsWith("/") ? url : `/${url}`;
      this.$router.push(target).catch(() => {
        window.location.href = target;
      });
    },
    triggerUnreadAttention() {
      if (typeof window === "undefined") return;
      this.attentionPulse = true;
      if (this.attentionTimeout) {
        clearTimeout(this.attentionTimeout);
      }
      this.attentionTimeout = setTimeout(() => {
        this.attentionPulse = false;
        this.attentionTimeout = null;
      }, 1600);
    },
  },
  watch: {
    unreadCount: {
      immediate: true,
      handler(newValue, oldValue) {
        const previous = typeof oldValue === "number" ? oldValue : 0;
        if (newValue > previous) {
          this.triggerUnreadAttention();
        }
      },
    },
    "$route.fullPath": {
      immediate: true,
      handler() {
        this.$nextTick(this.rememberCurrentRoute);
      },
    },
    navigationItems() {
      this.$nextTick(this.rememberCurrentRoute);
    },
    currentTenantId() {
      this.lastMenuPathByRoot = {};
      this.restoreNavigationMemory();
      this.$nextTick(this.rememberCurrentRoute);
    },
    "$store.state.dashboardCacheVersion"() {
      this.lastMenuPathByRoot = {};
      this.$nextTick(this.rememberCurrentRoute);
    },
    toggleActive(val) {
      if (this.$vuetify.breakpoint.mobile) {
        this.togglerActive = !!val;
      }
    },
    "$vuetify.breakpoint.mobile"(isMobile) {
      this.togglerActive = isMobile ? !!this.toggleActive : false;
    },
  },
};
</script>

<style scoped>
.top-menu-switch {
  align-items: center;
  background: rgba(248, 250, 252, 0.86);
  border: 1px solid rgba(52, 71, 103, 0.08);
  border-radius: 8px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.76);
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  margin: 0.15rem 0.25rem 0.25rem;
  padding: 0.45rem;
  width: 100%;
}

.top-menu-switch__item {
  background: transparent !important;
  border: 1px solid transparent;
  border-radius: 8px;
  box-shadow: none !important;
  color: #52667a !important;
  flex: 0 1 auto;
  height: 30px !important;
  letter-spacing: 0;
  max-width: 260px;
  min-width: 0 !important;
  padding: 0 0.7rem !important;
  text-transform: none;
  transition: background-color 0.18s ease, border-color 0.18s ease,
    color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
}

.top-menu-switch__item:hover {
  background: rgba(255, 255, 255, 0.9) !important;
  border-color: rgba(52, 71, 103, 0.12);
  box-shadow: 0 4px 10px rgba(52, 71, 103, 0.08) !important;
  color: #344767 !important;
  transform: translateY(-1px);
}

.top-menu-switch__item--active {
  background: #ffffff !important;
  border-color: rgba(33, 82, 255, 0.26);
  color: #2152ff !important;
  box-shadow: 0 5px 14px rgba(33, 82, 255, 0.14) !important;
}

.top-menu-switch__item--active .v-icon {
  color: #2152ff !important;
}

.top-menu-switch__label {
  display: block;
  max-width: 205px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.top-menu-mobile {
  margin: 0.15rem 0.25rem 0.25rem;
  width: 100%;
}

.top-menu-mobile__trigger {
  background: rgba(248, 250, 252, 0.96) !important;
  border: 1px solid rgba(52, 71, 103, 0.12);
  border-radius: 8px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.86) !important;
  color: #344767 !important;
  height: 40px !important;
  justify-content: flex-start;
  letter-spacing: 0;
  padding: 0 0.85rem !important;
  text-transform: none;
}

.top-menu-mobile__trigger-label {
  display: block;
  flex: 1 1 auto;
  font-weight: 600;
  min-width: 0;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.top-menu-mobile__content {
  border-radius: 8px;
  box-shadow: 0 12px 28px rgba(52, 71, 103, 0.18);
  overflow: hidden;
}

.top-menu-mobile__list {
  max-height: 360px;
  overflow-y: auto;
  padding: 0.35rem;
}

.top-menu-mobile__item {
  border-radius: 8px;
  color: #52667a;
  min-height: 38px;
}

.top-menu-mobile__item--active {
  background: rgba(33, 82, 255, 0.08);
  color: #2152ff;
}

.top-menu-mobile__item--active .v-icon,
.top-menu-mobile__item--active .top-menu-mobile__item-title {
  color: #2152ff !important;
}

.top-menu-mobile__item-title {
  font-size: 0.86rem;
  line-height: 1.25rem;
}

.notification-badge-wrapper {
  position: relative;
}

.notification-badge-wrapper .v-badge__wrapper,
.notification-badge-wrapper .v-badge__badge {
  position: relative;
  z-index: 1;
}

.notification-badge-wrapper--unread::after {
  content: "";
  position: absolute;
  inset: -3px;
  border-radius: 999px;
  border: 1px solid rgba(229, 57, 53, 0.28);
  pointer-events: none;
  z-index: 0;
  animation: notification-pulse 2.2s ease-out infinite;
}

.notification-badge-wrapper--boost::after {
  border-color: rgba(229, 57, 53, 0.55);
  animation: notification-pulse-fast 1.25s ease-out infinite;
}

.notification-badge-wrapper--boost .v-badge__badge {
  transform: scale(1.05);
  box-shadow: 0 6px 14px rgba(211, 47, 47, 0.5);
}

.notification-badge-wrapper--pulse::before {
  content: "";
  position: absolute;
  inset: -10px;
  border-radius: 999px;
  background: radial-gradient(
    circle,
    rgba(229, 57, 53, 0.28),
    rgba(229, 57, 53, 0) 70%
  );
  pointer-events: none;
  z-index: 0;
  animation: notification-spotlight 1.2s ease-out 1;
}

.notification-trigger {
  transition: background-color 0.25s ease, box-shadow 0.25s ease,
    transform 0.25s ease;
}

.notification-trigger--unread {
  background: linear-gradient(
    145deg,
    rgba(229, 57, 53, 0.2),
    rgba(229, 57, 53, 0.08)
  );
  box-shadow: 0 6px 16px rgba(229, 57, 53, 0.2);
}

.notification-trigger--unread:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 18px rgba(229, 57, 53, 0.26);
}

.notification-trigger--boost {
  animation: notification-boost-glow 2s ease-in-out infinite;
}

.notification-trigger--pulse {
  animation: notification-pop 1.1s ease-out 1;
}

.notification-alert {
  color: #d32f2f !important;
}

.notification-bell-ring {
  display: inline-block;
  transform-origin: center top;
  animation: notification-bell-ring 3.2s ease-in-out infinite;
}

.notification-bell-boost {
  display: inline-block;
  transform-origin: center top;
  animation: notification-bell-boost 1.6s ease-in-out infinite;
}

.notification-badge {
  font-weight: 700;
  font-size: 0.72rem;
  min-width: 22px;
  height: 22px;
  box-shadow: 0 4px 10px rgba(211, 47, 47, 0.35);
}

.notification-count-text {
  color: #b71c1c;
  border: 1px solid rgba(183, 28, 28, 0.35);
  background: linear-gradient(
    135deg,
    rgba(255, 235, 238, 0.95),
    rgba(255, 205, 210, 0.92)
  );
  font-weight: 700;
  letter-spacing: 0.01em;
  animation: notification-chip-breathe 2.8s ease-in-out infinite;
}

@keyframes notification-pulse {
  0% {
    opacity: 0.75;
    transform: scale(0.9);
  }
  70% {
    opacity: 0;
    transform: scale(1.18);
  }
  100% {
    opacity: 0;
    transform: scale(1.18);
  }
}

@keyframes notification-pulse-fast {
  0% {
    opacity: 0.9;
    transform: scale(0.92);
  }
  70% {
    opacity: 0;
    transform: scale(1.25);
  }
  100% {
    opacity: 0;
    transform: scale(1.25);
  }
}

@keyframes notification-spotlight {
  0% {
    opacity: 0;
    transform: scale(0.6);
  }
  25% {
    opacity: 0.85;
  }
  100% {
    opacity: 0;
    transform: scale(1.35);
  }
}

@keyframes notification-bell-ring {
  0%,
  65%,
  100% {
    transform: rotate(0deg);
  }
  70% {
    transform: rotate(-14deg);
  }
  75% {
    transform: rotate(12deg);
  }
  80% {
    transform: rotate(-10deg);
  }
  85% {
    transform: rotate(8deg);
  }
  90% {
    transform: rotate(0deg);
  }
}

@keyframes notification-bell-boost {
  0%,
  50%,
  100% {
    transform: rotate(0deg);
  }
  55% {
    transform: rotate(-18deg);
  }
  60% {
    transform: rotate(14deg);
  }
  65% {
    transform: rotate(-12deg);
  }
  70% {
    transform: rotate(10deg);
  }
  75% {
    transform: rotate(0deg);
  }
}

@keyframes notification-boost-glow {
  0% {
    box-shadow: 0 6px 16px rgba(229, 57, 53, 0.2);
  }
  50% {
    box-shadow: 0 12px 24px rgba(229, 57, 53, 0.38);
  }
  100% {
    box-shadow: 0 6px 16px rgba(229, 57, 53, 0.2);
  }
}

@keyframes notification-pop {
  0% {
    transform: scale(1);
  }
  30% {
    transform: scale(1.08);
  }
  60% {
    transform: scale(0.98);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes notification-chip-breathe {
  0% {
    box-shadow: 0 0 0 0 rgba(211, 47, 47, 0.18);
  }
  50% {
    box-shadow: 0 0 0 6px rgba(211, 47, 47, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(211, 47, 47, 0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .top-menu-switch__item,
  .notification-badge-wrapper--unread::after,
  .notification-badge-wrapper--boost::after,
  .notification-badge-wrapper--pulse::before,
  .notification-bell-ring,
  .notification-bell-boost,
  .notification-count-text,
  .notification-trigger--boost,
  .notification-trigger--pulse {
    animation: none !important;
  }

  .notification-trigger,
  .notification-trigger--unread:hover {
    transform: none;
  }
}
</style>
